import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../../elements";
import MarketplaceActionModal from "../../../pages/mplacer/MarketplaceActionModal";

export default function MplacerProductsTableComponent({ thead, tbody, onRefresh, activeTab }) {
    const { t } = useContext(TranslatorContext);
    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);

    const [mpModal, setMpModal] = useState(false);
    const [selectedMpData, setSelectedMpData] = useState(null);

    useEffect(() => {
        setData(tbody || []);
    }, [tbody]);

    const handleMarketplaceClick = (e, product, mp) => {
        e.preventDefault();

        // Agar specific marketplace 'Sold' hai to modal open mat karo
        const isCurrentSold = mp?.status === "Sold" || mp?.showing === false || mp?.showing === 0;
        if (isCurrentSold) {
            return;
        }

        // Product ke kisi bhi marketplace mein status 'Sold' ya 'Hide' hone ki checking
        const hasAnySoldOrHidden = product?.marketPlace?.some(
            (m) => m?.status === "Sold" || m?.status === "Hide" || m?.showing === false || m?.showing === 0
        );

        setSelectedMpData({
            product,
            marketplace: mp,
            hasAnySoldOrHidden
        });
        setMpModal(true);
    };

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={index}>{t(item)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data && data.length > 0 ? (
                        data.map((item, index) => {
                            const pImage = process.env.REACT_APP_IMG_URL + (item?.card_img || item?.first_img || "");
                            const pTitle = item?.title || "N/A";
                            const pDescribe = item?.selling_style || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const style = item?.selling_style || "N/A";
                            const pQty = item?.product_qty ?? "N/A";

                            const pCategory = typeof item?.category === "object"
                                ? item?.category?.name
                                : (item?.category || "N/A");

                            const pBrand = typeof item?.brand === "object"
                                ? item?.brand?.name
                                : (item?.brand || "N/A");

                            const pricePresent = typeof item?.price === "object"
                                ? item?.price?.present
                                : (item?.price || item?.buying_price || item?.sell_price_dollar || 0);

                            const iconView = item?.action?.view || "visibility";
                            const iconEdit = item?.action?.edit || "edit";

                            return (
                                <tr key={item?.id || index}>
                                    <td>
                                        <div className="mc-table-check">
                                            {pCode}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mc-table-product md">
                                            {pImage && <img src={pImage} alt={pTitle} />}
                                            <div className="mc-table-group">
                                                <h6>{pTitle}</h6>
                                                <p>{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>

                                    <td>{pCategory}</td>
                                    <td>{pBrand}</td>
                                    <td>{style}</td>
                                    <td>
                                        <div className="mc-table-price">
                                            <p>{pricePresent}</p>
                                        </div>
                                    </td>
                                    <td>{pQty}</td>

                                    <td>
                                        <div className="d-flex align-items-center gap-1 flex-wrap">
                                            {item?.marketPlace && item?.marketPlace?.length > 0 ? (
                                                item.marketPlace.map((mp, i) => {
                                                    // Status evaluation from API
                                                    const rawStatus = mp?.status || (mp?.showing === false || mp?.showing === 0 ? "Sold" : "Unsold");
                                                    const isSold = rawStatus === "Sold" || mp?.showing === false || mp?.showing === 0;

                                                    // Badge color logic
                                                    let badgeClass = "bg-success";
                                                    if (isSold) badgeClass = "bg-danger";
                                                    else if (rawStatus === "Hide" || rawStatus === "Hidden") badgeClass = "bg-warning text-dark";

                                                    return (
                                                        <button
                                                            key={i}
                                                            type="button"
                                                            disabled={isSold}
                                                            onClick={(e) => handleMarketplaceClick(e, item, mp)}
                                                            title={`${mp?.name} (${rawStatus})`}
                                                            className={`border rounded p-1 shadow-sm d-inline-flex align-items-center gap-1 btn btn-link ${isSold ? "bg-light opacity-75" : "bg-white"
                                                                }`}
                                                            style={{
                                                                textDecoration: 'none',
                                                                cursor: isSold ? 'not-allowed' : 'pointer'
                                                            }}
                                                        >
                                                            <img
                                                                src={process.env.REACT_APP_IMG_URL + mp?.logo}
                                                                alt={mp?.name}
                                                                style={{ width: "20px", height: "20px", objectFit: "contain" }}
                                                            />
                                                            <span className={`badge ${badgeClass}`} style={{ fontSize: "10px" }}>
                                                                {rawStatus}
                                                            </span>
                                                        </button>
                                                    );
                                                })
                                            ) : (
                                                <span className="text-muted small">None</span>
                                            )}
                                        </div>
                                    </td>

                                    <td>
                                        <div className="mc-table-action">
                                            <AnchorComponent to={'/mplacer-products-view'} state={{ item }} title="View" className="material-icons view">
                                                {iconView}
                                            </AnchorComponent>
                                            {activeTab === "new" && (
                                                <AnchorComponent
                                                    to={'/mplacer-products-edit'}
                                                    state={{ item }}
                                                    title="Edit"
                                                    className="material-icons edit"
                                                >
                                                    {iconEdit}
                                                </AnchorComponent>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 9} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <MarketplaceActionModal
                show={mpModal}
                onHide={() => setMpModal(false)}
                selectedData={selectedMpData}
                onSuccess={onRefresh}
                activeTab={activeTab}
            />

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_product")}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={() => setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}